import axios from "axios";
import AuthService from "./auth";

const API_URL = process.env.REACT_APP_API_URL + "/api";

class LaunchService {
    /**
     * Hydration call from /launch-entry. Returns:
     *   { is_remote, venue_id, player, card_number, prefill, promo_id,
     *     display_options: { keyboard: "on" | "off" | "small",
     *                        print_receipt: bool,
     *                        registration_mode: "prompt" | "trusted" } }
     */
    getSession(sessionId){
        var auth = AuthService.getCurrentAuth();
        var token = auth && auth.access;
        return axios.get(API_URL + "/launch/session", {
            params: { sid: sessionId },
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        }).then(r => r.data);
    }
}

export default new LaunchService();
